const CryptoJS = require("crypto-js");

// We use Base64 encoding to obscure the stored credentials in localStorage.
// This avoids needing any hardcoded encryption keys in the frontend bundle.
const encryptEmail = (email) => {
  if (!email) return "";
  return btoa(encodeURIComponent(email));
};

const encryptPassword = (password) => {
  if (!password) return "";
  return btoa(encodeURIComponent(password));
};

const decryptEmail = (email) => {
  try {
    return decodeURIComponent(atob(email));
  } catch (e) {
    return ""; // Fallback if it was encrypted with the old AES method or corrupted
  }
};

const decryptPassword = (password) => {
  try {
    return decodeURIComponent(atob(password));
  } catch (e) {
    return ""; // Fallback if it was encrypted with the old AES method or corrupted
  }
};

/**
 * Encrypt payload using a given AES-256 key (base64-encoded).
 * The key parameter is REQUIRED — no hardcoded fallback for API payloads.
 * Format: Base64(IV + Ciphertext)
 */
const encryptPayload = (data, keyBase64) => {
  if (!data) return data;
  if (!keyBase64) {
    console.error("encryptPayload: No session encryption key available");
    return null;
  }

  const jsonStr = JSON.stringify(data);
  const key = CryptoJS.enc.Base64.parse(keyBase64);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(jsonStr, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  const combined = iv.concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
};

/**
 * Decrypt payload using a given AES-256 key (base64-encoded).
 * The key parameter is REQUIRED — no hardcoded fallback for API payloads.
 */
const decryptPayload = (encryptedStr, keyBase64) => {
  if (!encryptedStr) return encryptedStr;
  if (!keyBase64) {
    console.error("decryptPayload: No session encryption key available");
    return encryptedStr;
  }

  try {
    const key = CryptoJS.enc.Base64.parse(keyBase64);
    const rawData = CryptoJS.enc.Base64.parse(encryptedStr);

    const iv = CryptoJS.lib.WordArray.create(rawData.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(rawData.words.slice(4));

    const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedStr);
  } catch (e) {
    console.error("Decryption error", e);
    return encryptedStr;
  }
};


export default { encryptEmail, encryptPassword, decryptEmail, decryptPassword, encryptPayload, decryptPayload }